// Imports
import * as React from "react"
import { useState } from "react";
import { Header, Footer } from "@layout"
import { ModalContenxtProvider } from "@modal"
import { CookiePanel } from "@molecules"

export const Layout = ({ children, light }) => {
  const [isCookiesAccepted, setIsCookiesAccepted ] = useState(false);

  return (
    <ModalContenxtProvider>
      <Header light={light} />
      {children}
      <Footer />
      <CookiePanel
        isCookiesAccepted={isCookiesAccepted}
        setIsCookiesAccepted={setIsCookiesAccepted}
      />
    </ModalContenxtProvider>
  )
}
